import { render, staticRenderFns } from "./UpcomingJobsList.vue?vue&type=template&id=7bf55ffb"
import script from "./UpcomingJobsList.vue?vue&type=script&lang=ts"
export * from "./UpcomingJobsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports